import { InfoOutlined } from "@mui/icons-material";
import { Box, Card, CardHeader, Stack, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { ContainerGrid, ViewToggleButtonGroup } from "../../../components";
import { useBreakpoints, useSettings } from "../../../hooks";
import { UserStrategicOwnershipContent } from "./UserStrategicOwnershipContent";
import { UserStrategyFilterButton } from "./UserStrategyFilterButton";

interface IParams {
  userId: string;
}

const UserStrategyPage = () => {
  const { userId: userGuid } = useParams<keyof IParams>() as IParams;
  const { isMdUp } = useBreakpoints();
  const { userStrategySettings, updateUserStrategySettings } = useSettings();
  const [isTableView, setIsTableView] = useState(userStrategySettings[userGuid]?.tableView ?? true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsTableView(userStrategySettings[userGuid]?.tableView ?? true);
  }, [userStrategySettings, userGuid]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(userStrategySettings[userGuid]?.tableView ?? true);
    } else {
      setIsTableView(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMdUp, userGuid]);

  function handleViewToggled(value: boolean) {
    updateUserStrategySettings(userGuid, {
      ...userStrategySettings[userGuid],
      tableView: value,
    });
  }

  return (
    <ContainerGrid container spacing={1}>
      <ContainerGrid size={12}>
        <Card sx={{ p: 1 }}>
          <Stack direction="row" spacing={1} sx={{ justifyContent: "space-between", alignItems: "center" }}>
            <Stack>
              <Typography variant="h5">Strategy</Typography>
              <Typography>Personal ownership of strategic items</Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{
              alignItems: "center"
            }}>
              {isMdUp && <ViewToggleButtonGroup isTableView={isTableView} onViewToggled={handleViewToggled} />}
            </Stack>
          </Stack>
        </Card>
      </ContainerGrid>
      <ContainerGrid size={{ xs: 12, md: isTableView ? 12 : 8 }} offset={{ md: isTableView ? 0 : 2 }}>
        <Card>
          <CardHeader
            title={
              <Stack direction="row" spacing={0.25} sx={{
                flexGrow: 1
              }}>
                <Typography variant="h6">Strategic Ownership</Typography>
                <Tooltip title={"This view includes all owned strategic items."}>
                  <InfoOutlined sx={{ color: "text.secondary", alignSelf: "center" }} />
                </Tooltip>
              </Stack>
            }
            action={<UserStrategyFilterButton userGuid={userGuid} disabled={isLoading} />}
          />
          <Box sx={{ px: 0.5, pb: 0.5 }}>
            <UserStrategicOwnershipContent
              userGuid={userGuid}
              onLoaded={() => setIsLoading(false)}
              isTableView={isTableView}
            />
          </Box>
        </Card>
      </ContainerGrid>
    </ContainerGrid>
  );
};

export { UserStrategyPage };
